import * as Types from '../../_generated/types.d';

import { GeocodeResponseData } from "@googlemaps/google-maps-services-js";
import { CoachState } from "@portal/app/_common/lib/coach";
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
export type ValidateLandingPageSlugQueryVariables = Types.Exact<{
  slug: Types.Scalars['String']['input'];
}>;


export type ValidateLandingPageSlugQuery = { __typename?: 'Query', validateLandingPageSlug: string | null };

export type GetMagicSearchAutocompleteQueryVariables = Types.Exact<{
  searchTerm: Types.Scalars['String']['input'];
}>;


export type GetMagicSearchAutocompleteQuery = { __typename?: 'Query', getMagicSearchAutocomplete: Array<{ __typename?: 'MagicSearchAutocompleteOption', id: string, name: string, industry: Types.VocationIndustry | null }> };

export type GetMagicSearchResultsQueryVariables = Types.Exact<{
  searchTerm: Types.Scalars['String']['input'];
}>;


export type GetMagicSearchResultsQuery = { __typename?: 'Query', getMagicSearchResults: { __typename?: 'MagicSearchResults', industry: Types.VocationIndustry | null, filters: { __typename?: 'MagicSearchFilters', program_environment: Array<Types.ProgramEnvironment> | null, program_level_in: Array<Types.ProgramLevel> | null, program_vocation_subindustries_in: Array<Types.VocationSubindustry> | null } } };

export type GetCustomerForPhoneWithVerifyQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCustomerForPhoneWithVerifyQuery = { __typename?: 'Query', viewerCustomer: { __typename?: 'Customer', id: string, user: { __typename?: 'User', id: string, phone: string | null, phoneVerified: boolean | null } | null } | null };

export type RequestCodeViaPhoneForPhoneWithVerifyMutationVariables = Types.Exact<{
  phone: Types.Scalars['String']['input'];
  isMobile?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type RequestCodeViaPhoneForPhoneWithVerifyMutation = { __typename?: 'Mutation', requestCodeViaPhone: boolean | null };

export type VerifyPhoneCodeForPhoneWithVerifyMutationVariables = Types.Exact<{
  code: Types.Scalars['String']['input'];
  phone: Types.Scalars['String']['input'];
}>;


export type VerifyPhoneCodeForPhoneWithVerifyMutation = { __typename?: 'Mutation', verifyPhoneCode: { __typename?: 'User', id: string, phone: string | null, phoneVerified: boolean | null, tokens: { __typename?: 'ClientAuthToken', accessToken: string, refreshToken: string } } };

export type CoachSummaryForCompletedStepQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CoachSummaryForCompletedStepQuery = { __typename?: 'Query', viewerCustomerCoachSummary: { __typename?: 'CoachSummaryResponse', coachSummary: { __typename?: 'CoachSummaryWithStatus', skipperType: Types.SkipperType | null, value: { __typename?: 'CoachSummary', skipperType: Types.SkipperType } | null } } };

export type GetDreamSearchParametersFromSearchQueryVariables = Types.Exact<{
  searchTerm: Types.Scalars['String']['input'];
}>;


export type GetDreamSearchParametersFromSearchQuery = { __typename?: 'Query', getDreamSearchParametersFromSearch: { __typename?: 'DreamSearchParameters', vocations: Array<{ __typename?: 'VocationWithRelated', vocation: { __typename?: 'Vocation', id: string, name: string, industry: Types.VocationIndustry, adjective: string }, relatedVocations: Array<{ __typename?: 'Vocation', id: string, name: string }> }> } };


export const ValidateLandingPageSlugDocument = gql`
    query validateLandingPageSlug($slug: String!) {
  validateLandingPageSlug(slug: $slug)
}
    ` as unknown as DocumentNode<ValidateLandingPageSlugQuery, ValidateLandingPageSlugQueryVariables>;
export const GetMagicSearchAutocompleteDocument = gql`
    query getMagicSearchAutocomplete($searchTerm: String!) {
  getMagicSearchAutocomplete(searchTerm: $searchTerm) {
    id
    name
    industry
  }
}
    ` as unknown as DocumentNode<GetMagicSearchAutocompleteQuery, GetMagicSearchAutocompleteQueryVariables>;
export const GetMagicSearchResultsDocument = gql`
    query getMagicSearchResults($searchTerm: String!) {
  getMagicSearchResults(searchTerm: $searchTerm) {
    industry
    filters {
      program_environment
      program_level_in
      program_vocation_subindustries_in
    }
  }
}
    ` as unknown as DocumentNode<GetMagicSearchResultsQuery, GetMagicSearchResultsQueryVariables>;
export const GetCustomerForPhoneWithVerifyDocument = gql`
    query getCustomerForPhoneWithVerify {
  viewerCustomer {
    id
    user {
      id
      phone
      phoneVerified
    }
  }
}
    ` as unknown as DocumentNode<GetCustomerForPhoneWithVerifyQuery, GetCustomerForPhoneWithVerifyQueryVariables>;
export const RequestCodeViaPhoneForPhoneWithVerifyDocument = gql`
    mutation requestCodeViaPhoneForPhoneWithVerify($phone: String!, $isMobile: Boolean = true) {
  requestCodeViaPhone(phone: $phone, isMobile: $isMobile)
}
    ` as unknown as DocumentNode<RequestCodeViaPhoneForPhoneWithVerifyMutation, RequestCodeViaPhoneForPhoneWithVerifyMutationVariables>;
export const VerifyPhoneCodeForPhoneWithVerifyDocument = gql`
    mutation verifyPhoneCodeForPhoneWithVerify($code: String!, $phone: String!) {
  verifyPhoneCode(code: $code, phone: $phone) {
    id
    phone
    phoneVerified
    tokens {
      accessToken
      refreshToken
    }
  }
}
    ` as unknown as DocumentNode<VerifyPhoneCodeForPhoneWithVerifyMutation, VerifyPhoneCodeForPhoneWithVerifyMutationVariables>;
export const CoachSummaryForCompletedStepDocument = gql`
    query coachSummaryForCompletedStep {
  viewerCustomerCoachSummary {
    coachSummary {
      skipperType
      value {
        skipperType
      }
    }
  }
}
    ` as unknown as DocumentNode<CoachSummaryForCompletedStepQuery, CoachSummaryForCompletedStepQueryVariables>;
export const GetDreamSearchParametersFromSearchDocument = gql`
    query getDreamSearchParametersFromSearch($searchTerm: String!) {
  getDreamSearchParametersFromSearch(searchTerm: $searchTerm) {
    vocations {
      vocation {
        id
        name
        industry
        adjective
      }
      relatedVocations {
        id
        name
      }
    }
  }
}
    ` as unknown as DocumentNode<GetDreamSearchParametersFromSearchQuery, GetDreamSearchParametersFromSearchQueryVariables>;